import { Component, Fragment } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../lib/applicationInsights';

interface TelemetryProviderProps {
    isDisabled: boolean;
    instrumentationKey: string | null;
    children: React.ReactElement;
    appId: string;
}

class TelemetryProvider extends Component<TelemetryProviderProps> {
    state = {
        initialized: false
    };

    componentDidMount() {
        const { isDisabled, instrumentationKey } = this.props;
        const { initialized } = this.state;

        if (!initialized && Boolean(instrumentationKey)) {
            ai.initialize(instrumentationKey, isDisabled);
            this.setState({
                initialized: true
            });
        }
    }

    render() {
        const { children } = this.props;
        return <Fragment>{children}</Fragment>;
    }
}

export default withAITracking(ai.reactPlugin, TelemetryProvider);
